// CSS
import './main.scss';

// Page transition & Scroll scale in
import { PageTransition } from '../global/utilities/page-transition';
import { ScaleIn } from '../global/utilities/scale-in';

new PageTransition(document.getElementById('site-body'));
new ScaleIn(document.querySelectorAll('.js-scale-in'));

// Global custom elements
import '../global/custom-elements/modal-dialog';
import '../global/custom-elements/modal-opener';
import '../global/custom-elements/deferred-media';
import '../global/custom-elements/footer-accordions';
import '../global/custom-elements/testimonials';
import '../global/custom-elements/text-icon-carousel';
